import { render, staticRenderFns } from "./product-inventory-print.vue?vue&type=template&id=5df96a2b&scoped=true&"
import script from "./product-inventory-print.vue?vue&type=script&lang=ts&"
export * from "./product-inventory-print.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df96a2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df96a2b')) {
      api.createRecord('5df96a2b', component.options)
    } else {
      api.reload('5df96a2b', component.options)
    }
    module.hot.accept("./product-inventory-print.vue?vue&type=template&id=5df96a2b&scoped=true&", function () {
      api.rerender('5df96a2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/views/product-inventory-print.vue"
export default component.exports